export const formatNumber = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const isNativeAmerican = (popGroups) => {
    const text = popGroups.join(';').toUpperCase(),
        codes = [
            "E0603",  // "american indians"
            "E0601", // "alaskan natives"
            "E0604" // "hawaiian natives"
        ];

    for(let i=0; i<codes.length; i++) {
        if (text.indexOf(codes[i]) > -1) {
            return true;
        }
    }
    return false;
}

export const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}


// WEBPACK FOOTER //
// ./src/components/Article/common/utilities.js